import Axios from '../utils/axios'

const mockRequest = (url: string, data: any, method = 'GET', callback) => {
  const reqData = method === 'GET' ? { params: data } : { data }
  Axios({
    url,
    method,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Client': 'car.xmart.com/V0.13.0_dev',
      'DN': 'CN=xmart.FuncTestHardware000',
      'DeviceId': 'FuncTestHardware000',
      'XP-Media-Sid': 'sid999999',
      'XP-Media-OpenId': 'OPEN999999',
      'XP-Media-Uid': '8008386',
      'XP-Client': 'car.xmart.com/V2.13.0_20211231140405_Release',
      'XP-Uid': '8008386',
      'CarType': 'f30',
      'xp-media-xima-sid': '251255b169194fbfbe2e32f6cd419072',
      'SignSkip': 'true'
    },
    ...reqData
  }).then(res => {
    callback && callback(res)
  }).catch(err => {})
}

// 通过大屏提供的bridge发起请求，约定使用window.xpVipBuyBridge
console.log('window.xpVipBuyBridge.requestUrl -->', window.xpVipBuyBridge?.requestUrl)

// url与回调函数映射池，key这里定为请求时传入的pathname，value为回调函数
let mediaVipCallbackMap = {}

// 注册回调函数给大屏执行callback
// 约定：大屏返回的url和当前请求的url一致时执行回调，大屏会传入完整url加上拼接参数
// 由于目前只有get，暂时只考虑get请求的情况，post请求需要再沟通确认
window['vipBuyCallBack'] = (requestUrl: string, result: string) => {
  console.log(requestUrl, 'vipBuyCallBack -->', result)

  try {
    if (Object.keys(mediaVipCallbackMap).length > 0) {
      const realUrl = new URL(requestUrl).pathname?.replace('/media', '')
      const callback = mediaVipCallbackMap[realUrl]
      callback && callback(JSON.parse(result))
    }
  } catch (error) {
    console.log('vipBuyCallBack error -->', JSON.stringify(error))
  }
}

console.log('window.vipBuyCallBack -->', window['vipBuyCallBack'])

// E29会员购买页主题色改为黄色 车端提供方法获取车型
export const getCarType = () => {
  let returnCarType = ''
  try {
    if (window.xpVipBuyBridge?.getCarType) {

      console.log('getCarType -->', window.xpVipBuyBridge.getCarType())

      returnCarType = window.xpVipBuyBridge.getCarType()
    }
  } catch (error) {
    console.log('getCarType error -->', error);
  }
  return returnCarType
}

// push回调函数池
const pushMediaVipCallbackMap = (url, callback) => {
  mediaVipCallbackMap[url] = callback
}

const request = (url: string, data: any, method = 'GET', callback) => {
  if (process.env.NODE_ENV === 'production') {
    try {
      // GET请求需要手动拼接参数到url上 ---> 影响签名算法处理，注释掉不拼接了
      // if (method === 'GET' && Object.keys(data).length > 0) {
      //   url += `?${Object.keys(data).map(key => `${key}=${data[key]}`).join('&')}`
      // }

      // push回调函数进池
      pushMediaVipCallbackMap(url, callback)

      // 把data对象转成json字符串传过去
      const jsonData = JSON.stringify(data)
      // 发起请求
      window.xpVipBuyBridge?.requestUrl(url, jsonData, method)
    } catch (error) {
      console.log('xpVipBuyBridge?.requestUrl error -->', error)
    }
  } else {
    // @ts-ignore
    mockRequest(url, data, method, callback)
  }
}

// 大屏的请求已经带了/media前缀，但本地开发环境需要加上
const urlPrefix = process.env.NODE_ENV === 'production' ? '' : '/media'

export function getXimalayaProductList(params, callback) {
  return request(`${urlPrefix}/v3/reading/pay/produceList`, params, 'GET', callback)
}

export function getXimalayaSignQrCode(params, callback) {
  return request(`${urlPrefix}/v3/reading/pay/signQrCode`, params, 'GET', callback)
}

export function getXimalayaSignStatus(params, callback) {
  return request(`${urlPrefix}/v3/reading/pay/signStatu`, params, 'GET', callback)
}

export function getXimalayaPayQrCode(params, callback) {
  return request(`${urlPrefix}/v3/reading/pay/payQrCode`, params, 'GET', callback)
}

export function getXimalayaPayStatus(params, callback) {
  return request(`${urlPrefix}/v3/reading/pay/payStatu`, params, 'GET', callback)
}

export function getKugouProductList(params, callback) {
  return request(`${urlPrefix}/v5/music/pay/productList`, params, 'GET', callback)
}

export function getKugouSignQrCode(params, callback) {
  return request(`${urlPrefix}/v5/music/pay/signQrCode`, params, 'GET', callback)
}

export function getKugouSignStatus(params, callback) {
  return request(`${urlPrefix}/v5/music/pay/signStatu`, params, 'GET', callback)
}

export function getKugouPayQrCode(params, callback) {
  return request(`${urlPrefix}/v5/music/pay/payQrCode`, params, 'GET', callback)
}

export function getKugouPayStatus(params, callback) {
  return request(`${urlPrefix}/v5/music/pay/payStatu`, params, 'GET', callback)
}